import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Account/ConfirmGuest/confirmGuest.container"
    ).then((module) => ({ default: module.ConfirmGuestContainer }))
);
